import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';



const DeliveryAddress = ({ deliveryData }) => {

    return (
        <div className="container">
            <div className="row">
                {
                    deliveryData.map((item, index) => (
                        <div className="col-sm-6" key={index}>
                            <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': { m: 1, width: '100%' },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <TextField id="standard-basic" value={item.states}
                                    name={`${item.name}`}
                                    autoComplete={`${item.name}`}
                                    onChange={(e) => item.setStates(e.target.value)} label={item.title} variant="standard" />
                            </Box>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default DeliveryAddress;